import {
  observable,
  action
} from 'mobx';
import base from '../../tool/base';
import {
  message
} from 'antd';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken
} = util;
const initSearchValue = {
  application: '',
  category: '-1'
}
const initParams = {
  searchValue: '',
  current: 1,
  count: 0,
  pageSize: 10,
  access_token: '',
  kind: 1,
  collect: 0,
  total: 0,
  offset: 0,
}
const initAddModal = {
  addWhere: "0",
  visible: false,
  title: "",
  datas: [], //存放添加项目数据，项目数据或方案数据
  cloumns: []
}
const initApplyModal = {
  visible: false,
  title: "申请表单"
}
const initProjSearchData = {
  projName: "",
    proj: "",
    type: "",
    appName: ""
}
const initSchemeSearchData = {
  schemeName: "",
  scheme: "",
  type: "",
  appName: ""
}
const initSearchData = {
  whereName: "",
  wherekey: "",
  type: "",
  appName: ""
}
export class CollectStore {
  @observable appDatas = [];
  // @observable whereDatas = [];
  // @observable whereType = "";
  // @observable current = 1;
  // @observable pageSize = 10;
  @observable selectedRows = [];
  @observable selected = false; //页面Table全选
  @observable loading = false;
  @observable searchValue = initSearchValue;
  @observable params = initParams;
  @observable addModal = initAddModal;
  @observable applyModal = initApplyModal;
  @observable leftMenu = "proj";
  @observable projSearchData = initProjSearchData;
  @observable schemeSearchData = initSchemeSearchData;
  @observable searchData = initSearchData;

  constructor(routing) {
    this.routing = routing;
    this.setPage = this.setPage.bind(this);
    this.callMyAppData = this.callMyAppData.bind(this);
    this.setSelectedRows = this.setSelectedRows.bind(this);
  }

  @action
  init = () => {
    this.searchValue = initSearchValue;
    this.params = initParams;
  }
  @action
  setSelectedRows(params = []) {
    this.selectedRows = params;
  }
  callMyAppData(param = {}) {
    let id = param.id;
    let kv = id === 'all' ?
      "-1" :
      id === 'workflow' ?
      "1" :
      id === 'portal' ?
      "2" :
      "-1";
    param.offset = (param.current - 1) * param.pageSize;
    this.params = {
      ...this.params,
      ...param,
      kind: kv,
      access_token: getAccessToken(),
    };
    this.loading = true;
    base.callApi('/v1/appCon', 'GET', this.params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
      //1、获取顶部导航
      if (data.status) {
        this.appDatas = data.apps;
        this.params.total = data.count;
      } else {
        message.info(data.msg);
        localStorage.removeItem('me');
      }
      this.loading = false;
    });
  }

  setPage(current, pageSize) {
    this.params.current = current;
    this.params.pageSize = pageSize;
  }

  callRemove(param, query, type) {
    let params = {
      collect: 1,
      access_token: getAccessToken(),
      ...param,
    };
    base.callApi('/v3/appcollect/edit4batch', 'POST', params, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        message.success("移除成功");
        this.callMyAppData(query);
        this.selectedRows = [];
        this.selected = false;
      } else {
        message.success(data.msg ? data.msg : '移除失败，请重试！');
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/stores/collect/CollectStore.js